export default __webpack_public_path__ + "static/media/eth.a55da4ad.png";